export { default } from './ViewTemplateDetailsModal';
